export default __webpack_public_path__ + "static/case2_img_3@2x-53c815c62034703aaf37728a0fcabc0d.webp";